import React from 'react';
import Icon from '@ant-design/icons';
import { Button, ButtonType } from 'components/Controls/Button';
import { SizeType } from 'antd/lib/config-provider/SizeContext';
import SettingsSvg from './settings.svg';

type IconButtonProps = {
  className?: string;
  size?: SizeType,
  iconSize?: number,
  onClick?: React.MouseEventHandler<HTMLElement>,
  type?: ButtonType,
};

export const SettingsIcon = (props: any) => <Icon component={SettingsSvg} {...props} />;

export const SettingsIconButton = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, IconButtonProps>(
  ({ size = 'medium', iconSize = 24, type = ButtonType.OutlineIcon, ...props }, ref) => (
    <Button
      ref={ref}
      type={type}
      icon={<SettingsSvg width={iconSize} height={iconSize} />}
      size={size}
      {...props}
    />
  ),
);
SettingsIconButton.displayName = 'SettingsIconButton';
